import { withCompController } from '@wix/editor-elements-integrations';
import type {
  ISlideshowMapperProps,
  ISlideshowControllerProps,
  ISlideshowProps,
} from '../../types';

export default withCompController<
  ISlideshowMapperProps,
  ISlideshowControllerProps,
  ISlideshowProps
>(({ mapperProps, controllerUtils, stateValues }) => {
  const { updateProps } = controllerUtils;
  const { reducedMotion } = stateValues;
  const { isPlaying } = mapperProps;

  return {
    ...mapperProps,
    reducedMotion,
    isPlaying: isPlaying && !reducedMotion,
    setCurrentIndex: (option1, option2) => {
      // TODO once TB will be released - remove this
      if (typeof option1 === 'number') {
        updateProps({
          currentIndex: option1,
          previewItemId: option2,
          navigatingForward: option1 > mapperProps.currentIndex,
        });
        return;
      }
      const { currentIndex, previewItemId = '', navigatingForward } = option1;
      updateProps({
        currentIndex,
        previewItemId,
        navigatingForward:
          navigatingForward ?? currentIndex > mapperProps.currentIndex,
      });
    },
  };
});
